import React, { useState } from "react";
import GoogleMapReact from "google-map-react";
import Rating from "@mui/material/Rating";
import AddLocationSharpIcon from "@mui/icons-material/AddLocationSharp";
import SearchBar from "../header/SearchBar";
import StartG from "../list/StartG";
import StartY from "../list/StartY";

export default function SimpleMap({
  coord,
  setCoord,
  setBounds,
  places,
  width,
  setZoom,
  setChildClick,
  weather
}) {
  const zoom = 15;

  const defaultProps = {
    center: {
      lat: 0.0,
      lng: 0.0,
    },
    zoom: 14,
  };

  return (
    <>
      {width === "s" ? (
        <div style={{ height: "100%", width: "100%" }}>
          <div className="absolute z-50 top-3 left-3 shadow-xl">
            <SearchBar setCoord={setCoord} width={width} />
          </div>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: process.env.REACT_APP_GOOGLE_API_KEY,
            }}
            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
            center={coord}
            margin={[50, 50, 50, 50]}
            onChange={(e) => {
              console.log(e.zoom);
              setZoom(e.zoom)
              setCoord({
                lat: e.center.lat,
                lng: e.center.lng,
              });
              setBounds({
                ne: e.bounds.ne,
                sw: e.bounds.sw,
              });
            }}
            onChildClick={(child) => {
              setChildClick(child);
            }}
          >
            {places?.map((place, key) => {
              return (
                <div
                  className="w-[6rem] pb-2 relative bg-[#f6f7fc] hover:bg-red-100 hover:z-[200]"
                  lat={place.latitude}
                  lng={place.longitude}
                  key={key}
                >
                  <h3 className="">{place.name ? place.name : <></>}</h3>
                  <div className="w-11/12 h-[3rem] overflow-hidden mx-auto">
                    <img
                      className="object-cover"
                      src={place.photo ? place.photo.images.small.url : ""}
                      alt={place.name}
                    />
                  </div>
                  <div className="w-11/12 h-1/4 overflow-hidden">
                    <Rating
                      value={place.rating ? place.rating : 0}
                      className="w-5/6"
                      size="small"
                      readOnly
                    />
                  </div>
                </div>
              );
            })}
            {weather?.list?.map((data,i)=>{
              return <div
              key = {i}
              lat={data.coord.lat}
              lng={data.coord.lng}
              >
                <img 
                src={`https://openweathermap.org/img/w/${data?.weather[0].icon}.png`} 
                alt="" />
              </div>
            })}
          </GoogleMapReact>
        </div>
      ) : (
        <div style={{ height: "100%", width: "100%" }}>
          <div className="absolute z-50 top-3 right-[60px] shadow-xl">
            <SearchBar setCoord={setCoord} width={width} />
          </div>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: "AIzaSyDHMV7z7V2EcQEwJyHc6cv7U_38PcUMrjo",
            }}
            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
            center={coord}
            margin={[50, 50, 50, 50]}
            onChange={(e) => {
              console.log(e.zoom);
              setZoom(e.zoom)
              setCoord({
                lat: e.center.lat,
                lng: e.center.lng,
              });
              setBounds({
                ne: e.bounds.ne,
                sw: e.bounds.sw,
              });
            }}
            onChildClick={(child) => {
              setChildClick(child);
            }}
          >
            {places?.map((place, key) => {
              return (
                <div
                  className="w-[7.8rem] pb-2 relative bg-[#f6f7fc] hover:bg-red-100 hover:z-[200]"
                  lat={place.latitude}
                  lng={place.longitude}
                  key={key}
                >
                  <h3 className="text-sm">{place.name ? place.name : <></>}</h3>
                  <div className="w-11/12 h-4/6 overflow-hidden mx-auto">
                    <img
                      className='object-cover'
                      src={place.photo ? place.photo.images.small.url : ""}
                      alt={place.name}
                    />
                  </div>
                  <div className="w-11/12 overflow-hidden">
                    <Rating
                      value={place.rating ? place.rating : 0}
                      className="w-5/6"
                      size="small"
                      readOnly
                    />
                  </div>
                </div>
              );
            })}
            {weather?.list?.map((data,i)=>{
              return <div
              key = {i}
              lat={data.coord.lat}
              lng={data.coord.lon}
              >
                <img 
                height={100}
                src={`https://openweathermap.org/img/w/${data.weather[0].icon}.png`} 
                alt="" />
                {console.log(data.weather[0])}
              </div>
            })}
          </GoogleMapReact>
        </div>
      )}
    </>
  );
}
// apiKey: 'AIzaSyA1mIzJHaNzlVsNQC_tvnONSmOWXiSoCeI'
